import createReducer from 'utils/createReducer';
import { combineReducers } from 'redux';
import {
  FEATURE_FLAGS_LOAD,
  FEATURE_FLAGS_LOAD_FAILURE,
  FEATURE_FLAGS_LOAD_SUCCESS,
} from './types';

/**
 * Whether feature flags are ready. If feature flag service fails to load for
 * any reason, we still set this to `true`. User will see a less-featured app
 * instead of blank page.
 */
const isReady = createReducer(false, {
  [FEATURE_FLAGS_LOAD]: () => false,
  [FEATURE_FLAGS_LOAD_FAILURE]: () => true,
  [FEATURE_FLAGS_LOAD_SUCCESS]: () => true,
});

const items = createReducer(
  {},
  {
    [FEATURE_FLAGS_LOAD]: () => ({}),

    [FEATURE_FLAGS_LOAD_SUCCESS]: (draft, { payload }) => {
      payload.flags.forEach(flag => {
        draft[flag.id] = flag;
      });
    },
  }
);

export default combineReducers({
  isReady,
  items,
});
